import React from 'react';
import './MetricTiles.css';

export function BoltScoreTile({ score = 34 }) {
  const tiers = [
    ['LOW', '#ff6b6b'],
    ['LIMITED', '#f09a30'],
    ['MODERATE', '#e8a940'],
    ['GOOD', '#5bc47a'],
    ['STRONG', '#2cc4a0'],
    ['ELITE', '#4a9ee8'],
  ];
  const activeIndex = score < 10 ? 0 : score < 20 ? 1 : score < 30 ? 2 : score < 40 ? 3 : score < 60 ? 4 : 5;

  return (
    <article className="ayro-metricTile ayro-metricTile--wide ayro-tone-bolt">
      <div className="ayro-topGlow" />
      <div className="ayro-metricTile__header">
        <p>BOLT SCORE</p>
        <span style={{ '--badge-color': tiers[activeIndex][1] }}>{tiers[activeIndex][0]} - Level {activeIndex + 1}</span>
      </div>
      <div className="ayro-boltBody">
        <div className="ayro-bigMetric">
          <span>{score}</span>
          <em>seconds</em>
        </div>
        <div className="ayro-boltScale" aria-label="BOLT score range">
          <div className="ayro-boltLabels">
            {tiers.map(([label, color], index) => (
              <span key={label} style={{ color: index === activeIndex ? color : undefined }}>{label}</span>
            ))}
          </div>
          <div className="ayro-boltBars">
            {tiers.map(([label, color], index) => (
              <span key={label} className={index === activeIndex ? 'is-active' : ''} style={{ backgroundColor: color }} />
            ))}
          </div>
        </div>
      </div>
    </article>
  );
}

export function SparkMetricTile({ title, rangeLabel, value, unit, delta, tone, points }) {
  return (
    <article className={`ayro-metricTile ayro-tone-${tone}`}>
      <div className="ayro-topGlow" />
      <div className="ayro-metricTile__header">
        <p>{title}</p>
        <span>{rangeLabel}</span>
      </div>
      <div className="ayro-compactBody">
        <div className="ayro-compactStats">
          <div className="ayro-smallMetric">
            <span>{value}</span>
            <em>{unit}</em>
          </div>
          <p>{delta}</p>
        </div>
        <MiniSparkline values={points} />
      </div>
    </article>
  );
}

function MiniSparkline({ values }) {
  const width = 180;
  const height = 58;
  const lo = Math.min(...values) - 1;
  const hi = Math.max(...values) + 1;
  const range = Math.max(hi - lo, 1);
  const coords = values.map((value, index) => {
    const x = values.length <= 1 ? width / 2 : (index / (values.length - 1)) * width;
    const y = height - ((value - lo) / range) * height;
    return [x, y];
  });
  const line = coords.map(([x, y], index) => `${index === 0 ? 'M' : 'L'} ${x.toFixed(2)} ${y.toFixed(2)}`).join(' ');
  const area = coords.length ? `M 0 ${height} ${line} L ${width} ${height} Z` : '';

  return (
    <svg className="ayro-miniSparkline" viewBox={`0 0 ${width} ${height}`} role="img" aria-label="Metric trend">
      <path d={area} className="ayro-sparkArea" />
      <path d={line} className="ayro-sparkLine" />
    </svg>
  );
}
